import { render, staticRenderFns } from "./signBoard.vue?vue&type=template&id=b2aacb10&scoped=true&"
import script from "./signBoard.vue?vue&type=script&lang=js&"
export * from "./signBoard.vue?vue&type=script&lang=js&"
import style0 from "./signBoard.vue?vue&type=style&index=0&id=b2aacb10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2aacb10",
  null
  
)

export default component.exports